module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('div', {
    staticClass: "cb-notebar",
    class: [_vm.customClass, _vm.notesSecondaryClass, _vm.noteTypeClass]
  }, [_c('div', {
    staticClass: "cb-notebar__wrap"
  }, [(_vm.type) ? _c('div', {
    staticClass: "cb-notebar__icon"
  }, [(_vm.type == 'info' || _vm.type == 'warning' || _vm.type == 'error' || _vm.type == 'suggestion' || _vm.type == 'muted') ? _c('i', {
    staticClass: "icon-info-circle",
    class: 'cb-notebar__' + _vm.type
  }) : _c('i', {
    staticClass: "icon-exclamation-circle cb-notebar__alert"
  })]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    directives: [{
      name: "cb-html",
      rawName: "v-cb-html",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "cb-notebar__content"
  }) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c266e10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/elements/Notes.vue
// module id = 121
// module chunks = 66 67 68 69